export default "__VITE_ASSET__5DGXZs2F__"